// @flow
import $ from 'jquery';
import Job from './Job';

const debug = require('../debug/debug')('wc:protocol:HttpJob');

/**
 * Generic HTTP job that provides a `cancel()` implementation.
 *
 * Subclasses must implement `this._xhr` and `this._promise`.
 *
 * @abstract
 */
export default class HttpJob extends Job {
  _xhr: $.jqXHR;

  constructor() {
    super();
    this._xhr = null;
  }

  get description() {
    const desc = super.description;
    return {
      label: `Network Task (${desc.status})`,
      tooltip: `URL: ${this._url}`,
      status: desc.status
    };
  }

  cancel() {
    if (!this._xhr) {
      debug('[cancel()] no xhr. return.');
      return;
    }

    if (this._canceled) {
      debug('[cancel()] canceled. return.');
      return;
    }

    if (this._done) {
      debug('[cancel()] done. return.');
      return;
    }

    debug('[cancel()] aborting xhr');
    this._xhr.abort();
    this._canceled = true;
  }
}
